import React, { useState } from "react";
import "./CheckBox.css"; // Optional: for styling

type props = {
  onCheckBoxClicked: (isChecked: boolean) => void;
  isHideText?: boolean;
  isSelected?: boolean;
};

const CheckBox: React.FC<props> = ({
  onCheckBoxClicked,
  isHideText,
  isSelected,
}) => {
  // State to manage checkbox checked status
  const [isChecked, setIsChecked] = useState(isSelected);

  // Handler for checkbox click
  const handleCheckboxClick = () => {
    onCheckBoxClicked(!isChecked); // Call the provided callback function with the new checked status
    setIsChecked((prevChecked) => !prevChecked);
  };

  return (
    <div className="checkbox-container">
      <div
        className={`custom-checkbox ${isChecked ? "checked" : ""}`}
        onClick={handleCheckboxClick}>
        {isChecked && <span className="checkmark">✔</span>}
      </div>
      {!isHideText && <div className="select-text">Select All</div>}
    </div>
  );
};

export default CheckBox;
